module.exports = __webpack_public_path__ + "img/hombre.ede8ff95.png";